import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}

/**
 * Where supabase-js keeps the session in localStorage. This is EXACTLY its own
 * default (`sb-<project ref>-auth-token`), spelled out so a sign-out can remove
 * the session itself when Supabase could not be told (lib/signOutCleanup.ts).
 * ⚠️ Never change the value: every signed-in person would be signed out.
 * Guard: supabase.storageKey.test.ts
 */
export const AUTH_STORAGE_KEY = `sb-${new URL(supabaseUrl).hostname.split('.')[0]}-auth-token`;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: AUTH_STORAGE_KEY,
  },
});

export type { User, Session } from '@supabase/supabase-js';
